// keys used for translations
// patient.modal.your-name
// patient.modal.patient-name
// patient.modal.your-fullname
// patient.modal.patient-fullname
const keys = ['your-name', 'patient-name', 'your-fullname', 'patient-fullname'];
export const DEFAULT_KEY_INDEX = 3;
export const getOptions = (intl) => {
    return keys.map((key, index) => {
        return {
            id: index + 1,
            key,
            label: intl.formatMessage({ id: `patient.modal.${key}` }),
        };
    });
};
export const getDefaultOption = (intl) => {
    return getOptions(intl)[DEFAULT_KEY_INDEX];
};
export const getTextByKey = (key, intl) => {
    const foundOption = getOptions(intl).find((option) => option.key === key);
    return foundOption ? foundOption.label : getDefaultOption(intl).label;
};
